import { NgIf } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IdleSessionService } from 'src/app/core/services/idle-session.service';
import { HeaderComponent } from '../header/header.component';
import { LoginComponent } from '../login/login.component';
import { LoginService } from '../login/login.service';

@Component({
    selector: 'app-home-freelancers',
    templateUrl: './home-freelancers.component.html',
    styleUrls: ['./home-freelancers.component.scss'],
    standalone: true,
    imports: [
        HeaderComponent,
        RouterOutlet,
        NgIf,
        LoginComponent,
    ],
})
export class HomeFreelancersComponent implements OnInit, OnDestroy {
    private readonly idleSessionService = inject(IdleSessionService);
    readonly loginService = inject(LoginService);

    ngOnInit(): void {
        this.idleSessionService.startMonitoring();
    }

    ngOnDestroy(): void {
        this.idleSessionService.stopMonitoring();
    }
}
